// Configurar feature flags de Vue.js
if (typeof window !== 'undefined') {
  window.__VUE_OPTIONS_API__ = true;
  window.__VUE_PROD_DEVTOOLS__ = false;
  window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Manejo de errores global
const app = createApp(App);

app.config.errorHandler = (err, vm, info) => {
  console.error('❌ Error global de Vue:', err);
  console.error('📍 Información del error:', info);
};

// Configuración de rendimiento
app.config.performance = true;

app.use(router);
app.mount('#app');
